import React from 'react';
import ApproveCount from 'components/MainMenu/Badges/ApproveCount';

const badgeTypes = {
  approveCount: ApproveCount
};

const NavBadge = ({ badge }) => {
  const Content = badgeTypes[badge];

  if (Content) {
    return <Content />;
  }

  return () => null;
};

export default NavBadge;



// WEBPACK FOOTER //
// ./src/components/MainMenu/NavBadge.js